import { Checkbox, FormControlLabel, TextField } from '@mui/material';
import { ADMIN_PAGE_LABELS as LABELS } from '../../../utils/labels';

interface LimitFieldProps {
  title: string;
  description: string;
  fieldLabel: string;
  unlimited: boolean;
  onUnlimitedChange: (unlimited: boolean) => void;
  value: string;
  onValueChange: (value: string) => void;
  error?: string;
}

export default function LimitField({
  title,
  description,
  fieldLabel,
  unlimited,
  onUnlimitedChange,
  value,
  onValueChange,
  error,
}: LimitFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <div>
        <p className="text-sm mt-0 text-primary uppercase mb-1">{title}</p>
        <p className="text-xs text-text-secondary mb-0 mt-0">{description}</p>
      </div>
      <FormControlLabel
        control={
          <Checkbox
            checked={unlimited}
            onChange={(e) => onUnlimitedChange(e.target.checked)}
          />
        }
        label={LABELS.unlimitedCheckbox}
      />
      <TextField
        label={fieldLabel}
        type="number"
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        disabled={unlimited}
        fullWidth
        error={!!error}
        helperText={error || undefined}
        slotProps={{ htmlInput: { min: 0, step: 1 } }}
      />
    </div>
  );
}
